import { MenuItem } from "@mui/material";
import { styled } from "@mui/system";

export const StyledMenuItem = styled(MenuItem)`
  font-size: 1.2rem;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.text.primary};
`;
